import TagsCombobox from "./tags";
import React from "react";

export default function ProjectTagsCombobox(props) {
  return <TagsCombobox for="projects" {...props} />;
}
